import { type FC } from "react";
import { Link } from "@root/shared/components/Link";
import { type UserDetails } from "@clientFrontend/features/scout/types/userDetails";
import { UserDetailContents } from "@clientFrontend/features/scout/components/UserDetailContents";

import * as styles from "./styles.css";

export type UserDetailShowPageContentsProps = UserDetails & {
  gaEvents: {
    scout: {
      gaAction: string;
      gaLabel: string;
    };
    premiumScout: {
      gaAction: string;
      gaLabel: string;
    };
  };
  scoutButtonContent: {
    scoutUrl: string;
    premiumScoutUrl: string;
  };
};

export const UserDetailShowPageContents: FC<UserDetailShowPageContentsProps> = ({
  gaEvents,
  labels,
  displayControlInformation,
  userData,
  historyInformation,
  hopedConditions,
  userProfileInformation,
  scoutButtonContent,
}) => {
  return (
    <>
      <UserDetailContents
        labels={labels}
        displayControlInformation={displayControlInformation}
        userData={userData}
        historyInformation={historyInformation}
        hopedConditions={hopedConditions}
        userProfileInformation={userProfileInformation}
      />
      {!displayControlInformation.isNotScoutable && (
        <div className={`${styles.btnArea} js-scout-user-detail-buttons`}>
          {scoutButtonContent.premiumScoutUrl && (
            <Link
              href={scoutButtonContent.premiumScoutUrl}
              theme="primary"
              className={styles.button}
              data-ga-action={gaEvents.premiumScout.gaAction}
              data-ga-label={gaEvents.premiumScout.gaLabel}
            >
              プレミアムスカウト
            </Link>
          )}
          {scoutButtonContent.scoutUrl && (
            <Link
              href={scoutButtonContent.scoutUrl}
              theme="secondary"
              className={styles.button}
              data-ga-action={gaEvents.scout.gaAction}
              data-ga-label={gaEvents.scout.gaLabel}
            >
              スカウト
            </Link>
          )}
        </div>
      )}
    </>
  );
};
